import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=71f4ce50&scoped=true&"
import script from "./Accounts.vue?vue&type=script&lang=ts&"
export * from "./Accounts.vue?vue&type=script&lang=ts&"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=71f4ce50&scoped=true&lang=scss&"
import style1 from "./Accounts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f4ce50",
  null
  
)

export default component.exports